import { Group } from 'business';
import { useBatchedQuery } from 'bridge';

export default function usePublicGroups(region?: string) : [Group[], () => void] {
    const [publicGroups, onLoadMorePublicGroups] = useBatchedQuery({ region: region, queryType: 'groupsPublic'});
    return [publicGroups, onLoadMorePublicGroups];
}
